<template>
    <div class="d-flex flex-column chatDiv">    
        <div class="d-flex justify-content-between ChatHeader align-items-center">
            <a @click="ToHome()" class="ChatPageIcon"><i class="fas fa-chevron-left fa-lg"></i></a>
            <span data-toggle="modal" data-target="#ChangeTitleModal" @click="OpenGroupChangeTitle()" >
                {{msgObjects.MsgType == 1 ? msgObjects.msgHistory.UserName : msgObjects.msgHistory.RoomName}}
            </span>
            <a class="ChatAddUser ChatPageIcon" data-toggle="modal" data-target="#ChatAddUserModal"><i class="fas fa-user-plus"></i></a>
        </div>
        <div class="chat_wp flex-grow-1 ChatBox d-flex flex-column" id="chat_wp" ref="chat_wp"  @scroll="TopScroll" >        
            <div class="chat_box" id="ChatBox" v-html="ChatBoxContent" @click="SettingImgUrl"></div>
            <div class="ChatKeyInOut mt-auto" v-if="IsKeyIn" v-bind:style="KeyInStyle()"><i class="fas fa-spinner fa-pulse fa-fw"></i>{{KeyInWord}}</div>

        </div>
        <div class="d-flex justify-content-between ChatFooter align-items-center">
            <a class="UploadFile ChatFileIcon" data-toggle="modal" data-target="#UploadFileModal"><i class="fas fa-paperclip fa-lg"></i></a>
            <textarea class="ChatFooterInput" v-model="TypingMsg" 
                @keydown.enter.exact.prevent="ChatInputEnterNextLine()" @keydown.enter.shift.exact.prevent="ChatInputShiftNextLine()"
                @focus="SendMsgOrFile(5)" @blur="SendMsgOrFile(6)">
            </textarea>
            <a  @click="SendMsgOrFile(1)" class="SendMsg b_blue ChatSendIcon" ><i class="fas fa-paper-plane fa-lg"></i></a>
        </div>

    <!-- ChatAddUserModal -->
        <div class="modal fade" id="ChatAddUserModal" tabindex="-1" aria-labelledby="ChatAddUserModalLabel" data-backdrop="static" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>Add User[Create Group or Invite in Group]</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div>
                            <span>Add UserID : </span>
                            <input type="text" class=" mt-2" v-model="AddUserId"/>
                        </div>
                    </div>
                    <div class="modal-footer ">
                        <div class=" d-flex justify-content-end ">
                            <button type="button" class="m-1 btn btn-secondary" data-dismiss="modal" @click="showBookingModal = false">Cancel</button>
                            <button type="button" class="m-1 btn btn-primary"  @click="AddUser()" data-dismiss="modal">Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    <!-- ChangeTitleModal -->        
        <div class="modal fade" id="ChangeTitleModal" tabindex="-1" aria-labelledby="ChangeTitleModalLabel" data-backdrop="static" aria-hidden="true" v-if="msgObjects.MsgType == 2">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>Change Title</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div class="d-flex flex-column">
                            <span>Title : </span>
                            <input type="text" class="my-2" v-model="GroupName"/>
                        </div>
                        <div class="d-flex flex-column">
                            <span>Group Member({{GroupMenberCount}}) : </span>
                            <textarea class="mt-2" readonly disabled>{{GroupMenberNames}}</textarea>
                        </div>
                    </div>
                    <div class="modal-footer ">
                        <div class=" d-flex justify-content-end ">
                            <button type="button" class=" m-1 btn btn-danger" data-dismiss="modal" @click="Quit()">Quit</button>
                            <button type="button" class=" m-1 btn btn-secondary" data-dismiss="modal" @click="showBookingModal = false">Cancel</button>
                            <button type="button" class=" m-1 btn btn-primary" @click="ChangeTitle()" data-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- UploadFileModal -->        
        <div class="modal fade" id="UploadFileModal" tabindex="-1" aria-labelledby="UploadFileModalLabel" data-backdrop="static" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5>Upload File</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div >
                            <span >File : </span>
                            <input type="file" id="FileInput" class="mt-2" ref="file" value=""/>
                        </div>
                    </div>
                    <div class="modal-footer ">
                        <div class=" d-flex justify-content-end ">
                            <button type="button" class=" m-1 btn btn-secondary" data-dismiss="modal" @click="showBookingModal = false">Cancel</button>
                            <button type="button" class=" m-1 btn btn-primary"  @click="SendMsgOrFile(2)" data-dismiss="modal">Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ImgPopUpModal -->        
        <div class="modal fade" id="ImgPopUpModal" tabindex="-1" aria-labelledby="ImgPopUpModalLabel" data-backdrop="static" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-body ">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div>
                            <img :src="PopUpImgUrl" class="PopupModalImg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

export default {
    name: 'Chat',
    components:{
        
    },
    data () {
        return {
            msgObjects:{},
            UserObject:{},
            Token:'',
            UserId:'',
            TypingMsg:'',
            ChatBoxContent:'',
            PreChatBoxContent:'',
            SentMsg:{},
            GroupName:'',
            GroupObject:{},
            GroupMenberCount:0,
            GroupMenberNames:'',
            MessageContents:[],
            AddUserId:'',
            // canGetOLderMsg:false,
            LastMsg:{},
            oldScrollHeight:0,
            LastMsgSendTime:'',
            PushDateTime:'',
            IsKeyIn:false,
            KeyInWord:'',
            PopUpImgUrl:'',
            msgDate:'',
            sending:false,
        }
    },
    methods:{
        //新增使用者ID(至群組或是新增群組)
        AddUser(){
            var data={
                "MessageType": this.msgObjects.MsgType,
                "UserIds": [parseFloat(this.AddUserId)]
            }
            
            if(this.msgObjects.MsgType == 2){
                //如果是群組 增加傳送GroupId
                data.GroupId = this.msgObjects.msgHistory.RoomId
                //目前所有群組人數都要傳送
                this.GroupObject.GroupUserList.forEach((item) => {
                    data.UserIds.push(item.GroupUserId);
                });
            }else if(this.msgObjects.MsgType == 1){
                //目前所有群組人數都要傳送
                data.UserIds.push(parseFloat(this.msgObjects.msgHistory.UserId))//對方
                data.UserIds.push(parseFloat(this.UserId))//自己
            }else{}//msgObjects.MsgType = 3 //announcement

            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/Invite`;

            axios.post(api, data, { headers })
                .then((response) => {
                    if(response.data.IsSuccess){ //成功
                        this.msgObjects.MsgType = 2
                        this.msgObjects.msgHistory.RoomId = response.data.GroupId
                        this.getMessagesAPI();
                        this.AddUserId = '';
                    }else{
                        alert("新增失敗：" + response.data.Message);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        Quit(){
            var data={
                "MessageType": this.msgObjects.MsgType,
                "UserIds": []
            }
            
            //如果是群組 增加傳送GroupId
            data.GroupId = this.msgObjects.msgHistory.RoomId
            //目前所有群組人數都要傳送
            this.GroupObject.GroupUserList.forEach((item) => {
                if(item.GroupUserId != this.UserId){
                    data.UserIds.push(item.GroupUserId);
                }
            });

            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/Quit`;

            axios.post(api, data, { headers })
                .then((response) => {
                    if(response.data.IsSuccess){ //成功
                        this.ToHome();

                        // this.msgObjects.MsgType = 2
                        // this.msgObjects.msgHistory.RoomId = response.data.GroupId
                        // this.getMessagesAPI();
                    }else{
                        alert("退出失敗：" + response.data.Message);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        //開啟變更群組標題modal
        OpenGroupChangeTitle(){
            //獲得資訊的API
            this.GroupName = this.msgObjects.msgHistory.RoomName;
        },
        // 變更群組名稱
        ChangeTitle(){
            if(this.GroupName == this.msgObjects.msgHistory.RoomName){ //沒有變更標題
                alert("群組名稱無變更！");
            }else{
                //Axios
                const headers = {"Authorization": 'Bearer '+this.Token};
                const api =`${process.env.APIPATH}/api/LiveChat/ChangeGroupName`;

                var data={
                    "GroupId": this.msgObjects.msgHistory.RoomId,
                    "GroupName": this.GroupName
                }

                axios.post(api, data, { headers })
                    .then((response) => {
                        if(response.data.IsSuccess){ //成功
                            this.msgObjects.msgHistory.RoomName = response.data.GroupName;
                        }else{
                            alert("更換失敗：" + response.data.Message);
                        }
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                    });
            }
        },
        //傳送文字訊息或檔案
        SendMsgOrFile(MessageType){
            var FormData = require('form-data');
            var fs = require('fs');
            var form = new FormData();
            form.append('MessageType', MessageType); // 1:msg 2:file 5:keyIn 6:keyOut 7:readed
            form.append('SendType', this.msgObjects.MsgType); // 1:Student, 2:Group = 2, 3:Announcement
            form.append('PushDateTime',new Date().toISOString());
            this.PushDateTime = new Date().toISOString();
            // 1:msg 2:file
            if(MessageType == 1){
                if(this.TypingMsg.trim() == ''){
                    return;
                }else{
                    form.append('Message', this.TypingMsg);
                }
            }else if(MessageType == 2){
                if(this.$refs.file.files[0] == undefined){
                    alert("未選擇檔案");
                    return;
                }else{
                    form.append('File', this.$refs.file.files[0]);
                }
            }
            //Receiver single/group
            if(this.msgObjects.MsgType == 1){//single
                form.append('Receiver', this.msgObjects.msgHistory.UserId);
            }else if(this.msgObjects.MsgType == 2){//group
                form.append('Receiver', this.msgObjects.msgHistory.RoomId);
            }
            
            if(MessageType == 1 || MessageType == 2){
                if(!this.sending){
                    this.SendMessageAPI(form);
                    this.sending = true;
                }
            }else{
                this.SendMessageAPI(form);
            }
        },
        //傳送訊息API
        SendMessageAPI(form){
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/SendMessage`;


            axios.post(api, form, { headers })
                .then((response) => {
                    if(response.data.IsSuccess){ //發送成功
                        this.SentMsg = response.data.MessageContent;
                        if(this.SentMsg.MessageType == 2){ //file
                            //判斷如果是圖片
                            if(this.checkFileType(this.SentMsg.Content.FileName.split(".").pop().toLowerCase())){ //true:圖片 false:不是圖片
                                this.SentMsg.showMessage = "<img id=\"ChatImgPreview\" class=\"ChatImgPreview\" data-toggle=\"modal\" data-target=\"#ImgPopUpModal\" src=\"" + this.SentMsg.Content.FileUrl + "\"><br/>"
                            }else{
                                this.SentMsg.showMessage = "";
                            }
                            this.SentMsg.showMessage += "<a href=\""+ this.SentMsg.Content.FileUrl +"\"><i class=\"fas fa-file-download\"></i>" + this.SentMsg.Content.FileName + "</a>"
                        }else if(this.SentMsg.MessageType == 1){ //msg
                            this.TypingMsg = '';
                            this.SentMsg.showMessage = this.SentMsg.Content.Message
                        }
                        this.PreChatBoxContent = '';

                        if(this.SentMsg.MessageType == 2 || this.SentMsg.MessageType == 1){
                            this.sending = false;
                            if(this.LastMsgSendTime != undefined){
                                if(moment(this.LastMsgSendTime).format('YYYYMMDD')  != moment(this.PushDateTime).format('YYYYMMDD')){
                                    this.AddDateMsg(this.PushDateTime);
                                    this.LastMsgSendTime = this.PushDateTime;
                                }
                            }
                            this.AddMeMsg(this.SentMsg);
                            this.ChatBoxContent += this.PreChatBoxContent;
                            this.ScrollToBottom();
                        }
                    }else{
                        alert("傳送失敗：" + response.data.Message);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        //初次進入聊天室獲取訊息API
        getMessagesAPI(){
            var data = {
                "SendType": this.msgObjects.MsgType,
            };
            if(this.msgObjects.MsgType == 1){ //single
                data.Receiver = this.msgObjects.msgHistory.UserId
                
            }else if(this.msgObjects.MsgType == 2){ //group
                data.GroupId= this.msgObjects.msgHistory.RoomId
            }

            //Axios
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/GetMessages`;

            axios.post(api, data, { headers })
                .then((response) => {
                    if(response.data.IsSuccess){ //發送成功
                        this.TypingMsg = '';
                        this.GroupObject = response.data.GroupObject;
                        this.MessageContents = response.data.MessageContents;
                        if(this.MessageContents.length > 0){  
                            this.LastMsgSendTime = this.MessageContents[(this.MessageContents.length-1)].SendDateTime;
                        }
                        this.UserObject = response.data.UserObject;

                        if(this.msgObjects.MsgType == 1){//單人
                            this.msgObjects.msgHistory.UserName = this.UserObject.UserName;
                        }else if(this.msgObjects.MsgType == 2) {//群組
                            this.msgObjects.msgHistory.RoomName = this.GroupObject.GroupName;
                            this.SetGroupData();
                        }
                        this.ChatBoxContent = '';
                        this.PreChatBoxContent = '';

                        this.SetMsgData();
                        this.ChatBoxContent = this.PreChatBoxContent;
                        this.ScrollToBottom();
                        this.ReadedMsg();
                    }
                    else{
                        this.GetMsgAPIError(response);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        SetGroupData(){
            //計算總人數
            this.GroupMenberCount = this.GroupObject.GroupUserList.length;
            this.GroupMenberNames = '';
            this.GroupObject.GroupUserList.forEach((item,index) => {
                this.GroupMenberNames += item.GroupUserId + "(" + item.GroupUserName + ")" ;
                if(index != (this.GroupMenberCount -1)){
                    this.GroupMenberNames += ", ";
                }
            });
        },
        SetMsgData(){
            // var msgDate='';
            this.MessageContents.forEach((item) => {
                if(item.MessageType == 2){ //file
                    //判斷如果是圖片
                    if(this.checkFileType(item.Content.FileName.split(".").pop().toLowerCase())){ //true:圖片 false:不是圖片
                        item.showMessage = '<img id=\"ChatImgPreview\" class="ChatImgPreview" data-toggle="modal" data-target="#ImgPopUpModal" src="' + item.Content.FileUrl + '"><br/>'
                    }else{
                        item.showMessage = "";
                    }                
                    item.showMessage += "<a href=\""+ item.Content.FileUrl +"\"><i class=\"fas fa-file-download\"></i>" + item.Content.FileName + "</a>"
                }else if(item.MessageType == 1){ //msg
                    item.showMessage = item.Content.Message
                }

                //如果是新的日期，要先新增日期訊息，再放上訊息
                if(this.msgDate == '' && this.ChatBoxContent == ''){ //first
                    this.AddDateMsg(item.SendDateTime);
                    this.msgDate = moment(item.SendDateTime).format('YYYYMMDD');
                }
                else if (this.msgDate == '' && this.ChatBoxContent != '' ){ //抓取舊資料要看是否要show新日期
                    // if(){
                        this.AddDateMsg(item.SendDateTime);
                        this.msgDate = moment(item.SendDateTime).format('YYYYMMDD');
                    // }
                }else if(moment(item.SendDateTime).format('YYYYMMDD') != this.msgDate){
                    this.AddDateMsg(item.SendDateTime);
                    this.msgDate = moment(item.SendDateTime).format('YYYYMMDD');
                }
                
                if(item.Sender == this.UserId){ //自己發送
                    this.AddMeMsg(item);
                }else{ //對方發送
                    this.AddLeftMsg(item);
                }
            });
        },
        AddDateMsg(date){
            this.PreChatBoxContent +=
                "<p class=\"" + moment(date).format('YYYYMMDD') + "\"><span>" + moment(date).format('YYYY/MM/DD dddd') + "</span></p>";
        },
        AddMeMsg(Content){
            this.PreChatBoxContent +=
                "<div class=\"box me " + Content.MessageId + "\"><div class=\"txt\"><p class=\"pNewline\">" + Content.showMessage +"</p></div><span>" + moment(Content.SendDateTime).format('HH:mm:ss') +"</span></div>"
        },
        AddLeftMsg(Content){
            this.PreChatBoxContent +=
                "<div class=\"box " + Content.MessageId + "\"><div class=\"text-start\"><span class=\"user\">" + Content.SenderName + "(" + Content.Sender + ")" + "</span><div class=\"txt\"><p class=\"pNewline\">" + Content.showMessage +"</p></div></div><span>" + moment(Content.SendDateTime).format('HH:mm:ss') +"</span></div>"
        },
        GetOlderMsgAPI(){
            var data = {
                "SendType": this.msgObjects.MsgType,
                "LastMessageId": this.MessageContents[0].MessageId,
            };
            if(this.msgObjects.MsgType == 1){ //single
                data.Receiver = this.msgObjects.msgHistory.UserId
                
            }else if(this.msgObjects.MsgType == 2){ //group
                data.GroupId= this.msgObjects.msgHistory.RoomId
            }

            //Axios
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/GetMessages`;

            axios.post(api, data, { headers })
                .then((response) => {
                    if(response.data.IsSuccess){ //發送成功
                        this.TypingMsg = '';
                        this.MessageContents = response.data.MessageContents;
                        //有更舊的訊息資料
                        if(this.MessageContents.length > 0){
                            this.PreChatBoxContent = '';
                            this.SetMsgData();
                            this.ChatBoxContent = this.PreChatBoxContent + this.ChatBoxContent;
                        }
                    }
                    else{
                        this.GetMsgAPIError(response);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        GetMsgAPIError(response){
            //Receiver = null(9991)
            if(!response.data.IsSuccess && response.data.ErrorCode == 9991){
                alert("載入失敗：" + response.data.Message);
            }
            //userid不存在 抓不到Receiver(9992)
            else if(!response.data.IsSuccess && response.data.ErrorCode == 9992){
                alert("使用者不存在");
                this.ToHome();
            }
            // SendType = Group 但GroupId = null(9993)
            else if(!response.data.IsSuccess && response.data.ErrorCode == 9993){
                alert("群組不存在" + response.data.Message);
            }
            else{
                alert("載入失敗：" + response.data.Message);
            }
        },
        
        //接收到WS最新消息
        getNewestMessages(item){
            //檢測傳送訊息者是現在對話框的人
            var canShow = false;
            var showMsg='';

            if(item.SendType == 1){//Student = 1,
                if(item.Sender == this.msgObjects.msgHistory.UserId){
                    canShow = !canShow;
                    //接收文字訊息
                    if(item.Content != undefined){
                        showMsg = item.Content.Message;
                    }

                    if(item.MessageType == 5){
                        this.KeyInWord = ' 對方正在輸入......';
                    }
                }
            }else if(item.SendType == 2){ // Group = 2, 
                if(item.Receiver == this.msgObjects.msgHistory.RoomId && item.Sender != this.UserId){//接收者是自己群組但不是自己傳送的訊息
                    canShow = !canShow;
                    if(item.Content != undefined){
                        showMsg = item.Content.Message;
                    }

                    if(item.MessageType == 5){
                        this.KeyInWord = item.SenderName + ' 正在輸入......';
                    }
                }
            }else if(item.SendType == 3){
                if(item.Content != undefined){
                    var msgData = JSON.parse(item.Content.Message);
                    if(msgData.GroupId == this.msgObjects.msgHistory.RoomId){// Announcement = 3
                        showMsg = msgData.Message;
                        canShow = !canShow;
                    }
                }
            }

            if(canShow){
                if(item.MessageType == 5){ //key in
                    this.IsKeyIn = true;

                    //如果scroll在最底部 
                    if(this.$refs.chat_wp.scrollTop == (this.$refs.chat_wp.scrollHeight - this.$refs.chat_wp.clientHeight)){
                        this.ScrollToBottom();
                    }
                }else if(item.MessageType == 6){//key out
                    this.IsKeyIn = false;
                }else if(item.MessageType == 1 || item.MessageType == 2){
                    //避免WS短時間內重複接收訊息
                    if(Object.keys(this.LastMsg).length == 0 || 
                        (Object.keys(this.LastMsg).length > 0 && showMsg != this.LastMsg.showMsg && 
                        moment(item.SendDateTime).format('YYYYMMDDHHmmss') != moment(this.LastMsg.SendDateTime).format('YYYYMMDDHHmmss'))) { 

                        if(item.MessageType == 2){ //file
                            item.showMessage = "<a href=\""+ item.Content.FileUrl +"\"><i class=\"fas fa-file-download\"></i>" + item.Content.FileName + "</a>"
                        }else if(item.MessageType == 1){ //msg
                            item.showMessage = item.Content.Message
                        }

                        this.PreChatBoxContent = '';
                        this.AddLeftMsg(item);
                        this.ChatBoxContent +=this.PreChatBoxContent;
                        this.ScrollToBottom();
                        item.showMsg = showMsg;
                        this.LastMsg = item;
                        
                        //已讀訊息
                        this.ReadMessageAPI([item.MessageId])
                    }
                }
            }
        },
        ReadedMsg(){
            var UnReadMsgIdList = [];
            this.MessageContents.forEach((item,index) => {
                if(item.Sender != this.UserId){
                    if(item.ReaderList.length > 0){
                        if(item.ReaderList.find(x => x.ReaderId == this.UserId) == undefined){
                            UnReadMsgIdList.push(item.MessageId);
                        }
                    }else{
                        UnReadMsgIdList.push(item.MessageId);
                    }
                }
            });
            if(UnReadMsgIdList.length > 0){
                this.ReadMessageAPI(UnReadMsgIdList);
            }
        },
        //已讀API
        ReadMessageAPI(data){
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/ReadMessages`;


            axios.post(api, {"MessageIdList": data}, { headers })
                .then((response) => {
                    if(response.data.IsSuccess){ //發送成功
                        // console.log('ReadMessages Success');
                    }else{
                        alert("傳送失敗：" + response.data.Message);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        ChatInputShiftNextLine(){
            this.TypingMsg+='\r\n';
            document.querySelector('.ChatFooterInput').style.height = "50px";
        },
        ChatInputEnterNextLine(){
            if(this.deviceType() == "desktop"){
                this.SendMsgOrFile(1);
            }else{
                this.TypingMsg+='\r\n';
                document.querySelector('.ChatFooterInput').style.height = "50px";
            }
        },
        //裝置判斷
        deviceType(){
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "desktop";
        },
        KeyInStyle(){
            if(this.IsKeyIn){
                return 'padding-top:20px'
            }else{
                return ''
            }
        },
        checkFileType(type){
            switch (type) {
                case "png":
                case "jpg":
                case "jpeg":
                case "gif":
                    return true;
                    break;
                default:
                    return false;
                    break;
            }
        },
        SettingImgUrl(e){
            if(e.target.id == 'ChatImgPreview'){
                this.PopUpImgUrl = e.target.src;
            }
        },
        //接收到新訊息的時候 畫面自動移至最下面
        ScrollToBottom(){
            if(this.$refs.chat_wp != undefined){
                this.$refs.chat_wp.scrollTop = this.$refs.chat_wp.scrollHeight
                this.$nextTick(()=>{
                    setTimeout(() => {
                        this.$refs.chat_wp.scrollTop = this.$refs.chat_wp.scrollHeight
                    },500)
                })
            }
        },
        TopScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if(scrollTop == 0){//在最上面
                //獲取更前面的訊息
                if(this.MessageContents.length == 50){
                    this.GetOlderMsgAPI();
                    this.$nextTick(()=>{
                        setTimeout(() => {
                            // 計算新加載的聊天消息高度
                            this.$refs.chat_wp.scrollTop = this.$refs.chat_wp.scrollHeight - scrollHeight
                            // this.$refs.chat_wp.scrollTop = scrollTop + scrollHeight - this.oldScrollHeight;
                        },600)
                    })

                }
            }
        },
        // chat_wp
        ToHome(){
            this.$router.push({
                name: 'Home',
                params: {
                    // NeedLogin:false,
                }
            });
        },
    },
    created(){
        this.$root.$refs.chat = this;
        if(this.$route.params.msgObjects == undefined){
            this.msgObjects = JSON.parse(localStorage.getItem('msgObjects'));
            // console.log(this.msgObjects);
            localStorage.setItem('msgObjects', null);
        }else{
            this.msgObjects = this.$route.params.msgObjects;
        }
        //WhereAmI || -1:home , other:msg room
        sessionStorage.setItem('WhereAmI',this.msgObjects.MsgType == 1 ? this.msgObjects.msgHistory.UserId:this.msgObjects.msgHistory.RoomId)
        this.Token = sessionStorage.getItem('Token')
        this.UserId = sessionStorage.getItem('UserId')
        this.getMessagesAPI()
        window.addEventListener('beforeunload',()=>{
            // console.log('beforeunload refresh page');
            var msgObjects = JSON.stringify(this.msgObjects);
            localStorage.setItem('msgObjects', msgObjects);
        })
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', () => {
            // console.log('remove refresh');
            return null
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Chat.vue